<script setup>
import { reactiveOmit } from '@vueuse/core';
import { ListboxGroup, ListboxGroupLabel, useId } from 'reka-ui';
import { computed, onMounted, onUnmounted } from 'vue';
import { cn } from '@/lib/utils';
import { provideCommandGroupContext, useCommand } from '.';

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
    heading: { type: String, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const { allGroups, filterState } = useCommand();
const id = useId();

const isRender = computed(() => (!filterState.search ? true : filterState.filtered.groups.has(id)));

provideCommandGroupContext({ id });
onMounted(() => {
    if (!allGroups.value.has(id)) allGroups.value.set(id, new Set());
});
onUnmounted(() => {
    allGroups.value.delete(id);
});
</script>

<template>
    <ListboxGroup
        :id="id"
        :class="
            cn(
                'text-foreground [&_[cmdk-group-heading]]:text-muted-foreground overflow-hidden p-1 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium',
                props.class,
            )
        "
        :hidden="isRender ? undefined : true"
        v-bind="delegatedProps"
    >
        <ListboxGroupLabel v-if="heading" class="flex items-center gap-1 px-2 py-1.5 text-xs font-medium uppercase">
            <hr class="w-2 border-t border-gray-300" />
            <span class="text-muted">{{ heading }}</span>
            <hr class="flex-grow border-t border-gray-300" />
        </ListboxGroupLabel>
        <slot />
    </ListboxGroup>
</template>
